import { teacherDashboardReducer } from './teacher_dashboard_reducers';

export default teacherDashboardReducer;
